import { mobileXXLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';
import { LinkText } from '../typography';

const mobileHeight = `max-height: 850px`;

export const CallAgentModalContainer = styled.div`
  width: 100%;
  text-align: left;
  display: flex;
  flex-direction: column;
  max-width: 550px;
  margin: 30px auto;

  @media screen and (${mobileXXLargeMax}), (${mobileHeight}) {
    margin: 0 auto;
  }
`;

export const CallAgentModalImage = styled.img`
  width: 100%;
  max-width: 200px;
  margin: 16px auto;
  display: flex;
`;

export const CallAgentModalOption = styled.div`
  color: ${({ theme }) => theme.textDark};
  font-size: 16px;
  margin: 15px 0px;
  text-align: center;
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const ContactText = styled.span`
  font-size: 24px;
  text-align: center;

  @media (${mobileXXLargeMax}) {
    font-size: 18px;
  }
`;

export const ContactNumber = styled(LinkText)`
  margin-top: 10px;
  font-size: 34px;
  font-weight: bold;
  display: block;
  color: ${(props) => props.theme.textDark};
  text-decoration: none;
  text-align: center;

  @media (${mobileXXLargeMax}) {
    font-size: 18px;
  }
`;

export const CallAgentContactDetails = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: calc(100% - 130px - 10px);
`;

export const AgentHeader = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1;
`;
